
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DeviceType } from '@/store/modules/app'
import { AppMain, Navbar, Sidebar } from './components'
import ResizeMixin from './mixin/resize'

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar
  }
})
export default class extends mixins(ResizeMixin) {
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    }
  }

  created(){
    window.dispatchEvent(new Event('into-home-page'))
    this.$store.dispatch('user/checkToken').then(()=>{
      console.log('nothing')
    }).catch(()=>{
      this.$router.push({name:'login'})
    })
    // this.$store.dispatch('user/getUserInfo')
  }





  private handleClickOutside() {
    this.$store.dispatch('app/closeSidebar',false)
  }
}
